import Service from './Service'
import { POLES } from './apiUrls'

export default class PoleService extends Service {
  getToUser (id) {
    return this.axios.get(`${POLES}/${id}/users`)
  }
  postUsersPole (id, data) {
    return this.axios.post(`${POLES}/${id}/users`, data)
  }
  deleteUsersPole (poleId, userId) {
    return this.axios.delete(`${POLES}/${poleId}/users/${userId}`)
  }

  getAllSharedUsers (poleId) {
    return this.axios.get(`${POLES}/${poleId}/accesses`)
  }
  postSharedUsers (poleId, data) {
    return this.axios.post(`${POLES}/${poleId}/accesses`, data)
  }
  deleteSharedUsers (poleId, userId) {
    return this.axios.delete(`${POLES}/${poleId}/accesses/${userId}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/PoleService.js